export default {
      id: "triangle-usage",
      viewBox: "0 0 10 6",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#triangle",
      toString: function () {
        return this.url;
      }
    }